import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleDealershipVehicleDealScreen from "../../../container/Vehicles/VehicleDealershipVehicleDealScreen";
import CreateVehicleDealershipVehicleDeal from "../../../container/Vehicles/VehicleDealershipVehicleDealScreen/CreateVehicleDealershipVehicleDeal";

const VehicleDealershipVehicleDealRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_DEALERSHIPVEHICLEDEAL.HOME}
          element={
            <VehicleDealershipVehicleDealScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_DEALERSHIPVEHICLEDEAL.CREATE}
          element={<CreateVehicleDealershipVehicleDeal />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_DEALERSHIPVEHICLEDEAL.EDIT}
          element={<CreateVehicleDealershipVehicleDeal isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleDealershipVehicleDealRoutes;
